import "./ira_acc.css"
import personal_img from "../../../assets/pers_img.webp";
import Logout from "../../logout/Logout";
import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
import apiClient from "../../../utils/axios";
import {connect} from "react-redux";
import {setOwnerData, setOwnerType, setSameAddType, setSpouseType} from "../../../redux/owner_info_store";
import {Link, useNavigate} from "react-router-dom";
import ProgressBar from "react-bootstrap/ProgressBar";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step32/`

function OwnerPersonalInfo({
                               ownerData,
                               setOwnerData,
                               personalData,
                               appData
                           }) {

    const {t} = useTranslation()

    const navigate = useNavigate()
    const now = 50

    const isValidDate = (dateString) => {
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!regex.test(dateString)) {
            return false;
        }

        const parts = dateString.split('/');
        const year = parseInt(parts[2], 10)
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const date = new Date(year, month, day);

        return (
            date.getDate() === day &&
            date.getMonth() === month &&
            date.getFullYear() === year
        );
    };

    const [ownerErrors, setOwnerErrors] = useState({
        joint_title: '',
        joint_first_name: '',
        joint_last_name: '',
        joint_middle_name: '',
        joint_birth: '',
        joint_ssn: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        setOwnerErrors({
            joint_title: '',
            joint_first_name: '',
            joint_last_name: '',
            joint_middle_name: '',
            joint_birth: '',
            joint_ssn: '',
        });

        let isValid = true;

        if (!ownerData.joint_title) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_title: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_first_name) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_first_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_last_name) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_last_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_birth || !isValidDate(ownerData.joint_birth)) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_birth: t('errors.valid_date')
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const dobDate = new Date(ownerData.joint_birth);
            const age = currentDate.getFullYear() - dobDate.getFullYear();

            if (age < 18) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_birth: t('errors.years_old_error'),
                }));
                isValid = false;
            }
        }

        if (!ownerData.joint_ssn) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_ssn: t('errors.required_field'),
            }));
            isValid = false;
        } else if (ownerData.joint_ssn.length !== 11) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_ssn: t('errors.enter_characters'),
            }));

            isValid = false;
        } else {
            if (ownerData.joint_ssn === personalData.ssn) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_ssn: t('errors.main_user_ssn'),
                }));
                isValid = false;
            }
        }

        if (isValid) {
            setOwnerData(ownerData);
            if (!appData.app_id) alert('Missing app id')

            try {
                await ownerApp()
                navigate('/conditions')
            } catch (error) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;

        if (name === 'joint_ssn') {
            value = value.replace(/\D/g, '');

            if (value.length === 9) {
                value = value.replace(/^(\d{3})(\d{2})(\d{4})$/, '$1-$2-$3');
            }

            setOwnerData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }

        if (name === 'joint_ssn') {
            if (!value) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_ssn: t('errors.required_field'),
                }));
            } else {
                if (value === personalData.ssn) {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: t('errors.main_user_ssn'),
                    }));
                }
                if (value.length === 11 && value.match(/^\d{3}-\d{2}-\d{4}$/)) {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: '',
                    }));
                } else {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: t('errors.enter_characters'),
                    }));
                }
            }
        }

        if (name === 'joint_birth') {
            const numericValue = value.replace(/\D/g, '');

            if (numericValue.length <= 2) {
                value = numericValue;
            } else if (numericValue.length <= 4) {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2)}`;
            } else {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2, 2)}/${numericValue.substr(4, 4)}`;
            }

            const isValid = isValidDate(value);

            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                [name]: isValid ? '' : t('errors.valid_date'),
            }));

            if (isValid) {
                const currentDate = new Date();
                const dateValue = new Date(value);

                if (name === 'joint_birth') {
                    const age = currentDate.getFullYear() - dateValue.getFullYear();
                    if (age < 18) {
                        setOwnerErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.years_old_error'),
                        }));
                    }
                }
            }
        }

        setOwnerData({
            ...ownerData,
            [name]: value,
        });
    };

    const formatDateInput = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    };

    const formatDateInputAPI = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
    };

    const getOwnerValues = () => {
        return {
            JointMemberOther: ownerData.joint_member,
        }
    };

    const ownerApp = async () => {
        try {
            const URL = HOST + appData.app_id
            const params = getOwnerValues()

            const parsedOwnerData = {
                ...ownerData,
                joint_birth: formatDateInputAPI(ownerData.joint_birth),
            }

            const response = await apiClient.put(URL, {
                ...parsedOwnerData,
                ...params
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            })

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    }

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={personal_img} alt=""/>
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>
                <div>
                    <p className="ira_info_heading text-center font-normal uppercase text-xl">{t('custodial.thanks')} {personalData.firstName} {personalData.lastName}. {t('modals.ira_modal.ira')}</p>
                    <p className="ira_info_heading text-center font-normal uppercase text-xl">{t('joint.joint_info')}</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-wrap gap-3">
                        <div className="ira_info_input_error">
                            <Form.Select aria-label="Default select example"
                                         name="joint_title"
                                         value={ownerData.joint_title}
                                         onChange={handleInputChange}
                            >
                                <option>{t('personal.title')}</option>
                                <option value="Mr.">{t('personal.mr')}</option>
                                <option value="Ms.">{t('personal.ms')}</option>
                                <option value="Mrs.">{t('personal.mrs')}</option>
                                <option value="Dr.">{t('personal.dr')}</option>
                            </Form.Select>
                            {ownerErrors.joint_title &&
                                <p className="text-red-500 mb-0 text-sm mt-2">{ownerErrors.joint_title}</p>}
                        </div>
                        <div className="ira_info_input_error">
                            <input className="ira_info_input w-full" placeholder={t('personal.first_name')}
                                   type="text"
                                   name="joint_first_name"
                                   value={ownerData.joint_first_name}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_first_name &&
                                <p className="text-red-500 mb-0 text-sm mt-2">{ownerErrors.joint_first_name}</p>}
                        </div>
                        <div className="flex flex-column w-full">
                            <input className="ira_info_input" placeholder={t('specialty.middle_name')}
                                   type="text"
                                   name="joint_middle_name"
                                   value={ownerData.joint_middle_name}
                                   onChange={handleInputChange}
                            />
                        </div>
                        <div className="flex flex-column w-full">
                            <input className="ira_info_input" placeholder={t('personal.last_name')}
                                   type="text"
                                   name="joint_last_name"
                                   value={ownerData.joint_last_name}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_last_name &&
                                <p className="text-red-500 mb-0 text-sm mt-2">{ownerErrors.joint_last_name}</p>}
                        </div>
                        <div className="ira_info_input_error">
                            <input
                                className="ira_info_input w-full"
                                placeholder={t('personal.date_of_birth')}
                                type="text"
                                name="joint_birth"
                                value={formatDateInput(ownerData.joint_birth)}
                                onChange={handleInputChange}
                            />
                            {ownerErrors.joint_birth &&
                                <p className="text-red-500 mb-0 text-sm mt-2">{ownerErrors.joint_birth}</p>}
                        </div>

                        <div className="ira_info_input_error">
                            <input className="ira_info_input w-full" placeholder={t('personal.ssn')} type="text"
                                   name="joint_ssn"
                                   maxLength={11}
                                   value={ownerData.joint_ssn}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_ssn &&
                                <p className="text-red-500 mb-0 text-sm mt-2">{ownerErrors.joint_ssn}</p>}
                        </div>

                    </div>
                    <div
                        className="flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column-reverse row-gap-3 pt-7">
                        <Link className="no-underline" to="/experience">
                            <button className="back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="continue_btn" type="submit">{t('next_btn')}</button>
                    </div>
                    <div>
                        {ownerErrors.submitError && (
                            <div className="text-red-500 text-center">
                                {ownerErrors.submitError}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    ownerData: state.ownerData,
    personalData: state.personalData,
    appData: state.appData
});

const mapDispatchToProps = {
    setOwnerData,
    setOwnerType,
    setSameAddType,
    setSpouseType
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnerPersonalInfo);